import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { CtaBand } from "@/components/CtaBand";
import { container } from "@/lib/ui";
import { breadcrumbSchema } from "@/lib/schema";

export function LegalLayout({ title, path, description, updated = "June 2026", crumbName, children }) {
  return (
    <>
      <Seo title={title} description={description} path={path}
        schema={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: crumbName, path }])]} />
      <PageHeader eyebrow="Legal" title={title} crumbs={[{ name: crumbName }]} subtitle={`Last updated: ${updated}`} />
      <section className="py-16 lg:py-20 bg-white">
        <div className={`${container} max-w-3xl`}>
          <div className="prose-legal space-y-8 text-gray-600 leading-relaxed">{children}</div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <div>
      <h2 className="font-heading text-xl font-bold text-navy mb-3">{heading}</h2>
      <div className="space-y-3 text-[15px]">{children}</div>
    </div>
  );
}
